import { useSelector } from 'react-redux';
import { modalSelector } from 'Store/modules/app/selectors';
import * as modals from 'Constants/modals';
import {
  BasicModal,
  WarningModal,
  PaymentMethod,
  MandatoryResult,
  ReviewModal,
  ShareModal,
  GratitudeModal,
  TaxSeasonOver,
  ClabeModal,
  PaymentMethodPY,
  DgModal,
  EntertaimentModal,
  FormEfirma,
  InstantRefundModal,
  ClabeForm,
  TaxSeasonInfo,
  EfirmaInfo,
  EfirmaPreviousYearModal,
} from './components';
import PdfModal from './components/PdfModal';

const MODAL_TYPES = {
  [modals.BASIC_MODAL]: BasicModal,
  [modals.WARNING_MODAL]: WarningModal,
  [modals.PDF_MODAL]: PdfModal,
  [modals.PAYMENT_METHOD_MODAL]: PaymentMethod,
  [modals.PAYMENT_METHOD_PA_MODAL]: PaymentMethodPY,
  [modals.RESULT_MANDATORY_MODAL]: MandatoryResult,
  [modals.REVIEW_MODAL]: ReviewModal,
  [modals.SHARE_MODAL]: ShareModal,
  [modals.GRATITUDE_MODAL]: GratitudeModal,
  [modals.TAX_SEASON_OVER_MODAL]: TaxSeasonOver,
  [modals.CLABE_MODAL]: ClabeModal,
  [modals.DG_MODAL]: DgModal,
  [modals.ENTERTAIMENT_MODAL]: EntertaimentModal,
  [modals.EFIRMA_MODAL]: FormEfirma,
  [modals.INSTANT_REFUND_MODAL]: InstantRefundModal,
  [modals.CLABE_FORM]: ClabeForm,
  [modals.TAX_SEASON_INFO]: TaxSeasonInfo,
  [modals.EFIRMA_INFO_MODAL]: EfirmaInfo,
  [modals.EFIRMA_PREVIOUS_YEAR]: EfirmaPreviousYearModal,
};

const Modal = (): JSX.Element | null => {
  const modal = useSelector(modalSelector);
  const { type, data } = modal.options;
  if (!type) {
    return null;
  }
  const Component = MODAL_TYPES[type];
  return <Component data={data} />;
};

export default Modal;
